import { __rest } from '../../_virtual/_tslib.js';
import classNames from 'classnames';
import React__default, { forwardRef, useRef, useImperativeHandle } from 'react';
import Search from '../search/Search.js';
import './SearchFlat.scss.js';
import Styles from './SearchFlat.module.scss.js';
import FlatInputStyles from '../flat-input/FlatInput.module.scss.js';

const SearchFlat = forwardRef((_a, forwardedRef) => {
    var { inputWrapperClassName, containerClassName, labelClassName, inputClassName } = _a, props = __rest(_a, ["inputWrapperClassName", "containerClassName", "labelClassName", "inputClassName"]);
    const searchRef = useRef(null);
    useImperativeHandle(forwardedRef, () => ({
        focus: () => { var _a; return (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }
    }));
    return (React__default.createElement(Search, Object.assign({ ref: searchRef, containerClassName: classNames(FlatInputStyles.inputContainer, containerClassName, "flatSearchContainer"), inputWrapperClassName: classNames(FlatInputStyles.inputWrapper, inputWrapperClassName), labelClassName: classNames(FlatInputStyles.label, labelClassName), inputClassName: classNames(FlatInputStyles.input, Styles.input, inputClassName), activeClassName: classNames(FlatInputStyles.active), dirtyClassName: classNames(FlatInputStyles.dirty) }, props)));
});

export { SearchFlat as default };
//# sourceMappingURL=SearchFlat.js.map
